import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLoader } from "../../../../context/LoadingContext";
import { listConsultationTypes } from "../../../../network/api/users/appointmentType/appointmentType";

export default function ServiceSelection({ services, setServices, selectedService, setSelectedService, doctorId }) {
    const { setLoading } = useLoader();

    useEffect(() => {
        async function fetchServices() {
            try {
                setLoading(true);
                const res = await listConsultationTypes(doctorId);
                setServices(res);
            } catch (error) {
                toast("Error fetching services, please try again later");
            } finally {
                setLoading(false);
            }
        }
        if (doctorId && doctorId !== "") {
            fetchServices();
        }
    }, [doctorId]);

    return (
        <div className="p-4 sm:p-3 sm:py-2 w-full">
            <div className="flex justify-between items-center mb-4 ">
                <div className=" w-full">
                    <h2 className="text-lg sm:text-xl font-bold text-center md:text-left">Select a Service</h2>
                    <h4 className="text-sm text-gray-500 text-center md:text-left">Choose the Type of Appointment you need</h4>
                </div>
            </div>
            {/* Responsive Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {services.map((service) => (
                    <div
                        key={service.id}
                        className={`p-4 border rounded-lg cursor-pointer transition duration-300 flex flex-col gap-1 ${
                            selectedService?.id === service.id
                                ? "border-black bg-gray-200"
                                : "border-gray-300 hover:border-black hover:bg-gray-50"
                        }`}
                        onClick={() => setSelectedService(service)}
                    >
                        <div>
                            <h3 className="font-semibold text-base sm:text-lg">{service.name}</h3>
                            <p className="text-sm text-gray-600">{service.description}</p>
                        </div>

                        <p className="text-sm text-gray-600">Charges: {service.fees}</p>
                    </div>
                ))}
            </div>

            {/* Selected Service Message */}
            {/* {selectedService && (
                <p className="mt-4 text-green-600 font-semibold text-center sm:text-left">
                    Selected Service Fees: {selectedService.fees}
                </p>
            )} */}
        </div>
    );
}
